import { Link } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { Note, Typography } from '@ocx/ui';

export type OfferDetailsTermsAndDisclaimerProps = {
  disclaimer?: string | null;
  disclaimerUrl?: string | null;
  terms?: string | null;
  termsUrl?: string | null;
};

export const OfferDetailsTermsAndDisclaimer = (props: OfferDetailsTermsAndDisclaimerProps) => {
  const { disclaimer, disclaimerUrl, terms, termsUrl } = props;

  return (
    <Note display="flex" flexDirection="column">
      {disclaimer && (
        <Typography variant="caption" color="textSecondary">
          {disclaimer}
        </Typography>
      )}
      {disclaimerUrl && (
        <Link href={disclaimerUrl} variant="caption" gutterBottom color="textSecondary" underline="always">
          <FormattedMessage
            id="offerDetailsPopup:disclaimerText"
            defaultMessage="Disclaimer"
            description="Disclaimer link title on the Offer Details popup"
          />
        </Link>
      )}
      {terms && (
        <Typography variant="caption" color="textSecondary">
          {terms}
        </Typography>
      )}
      {termsUrl && (
        <Link href={termsUrl} variant="caption" color="textSecondary" underline="always">
          <FormattedMessage
            id="offerDetailsPopup:termsAndConditionsText"
            defaultMessage="Terms & Conditions"
            description="Terms & Conditions link title on the Offer Details popup"
          />
        </Link>
      )}
    </Note>
  );
};
